const translations = {
  fr: {
    // Navigation
    "nav.home": "Accueil",
    "nav.features": "Fonctionnalites",
    "nav.security": "Securite & RGPD",
    "nav.pricing": "Tarifs",
    "nav.contact": "Contact",
    "nav.login": "Se connecter",
    "nav.getStarted": "Commencer",
    "nav.dashboard": "Mon espace",
    "nav.trips": "Mes plans",
    "nav.tasks": "Actions",
    "nav.budget": "Budget",
    "nav.compliance": "Formalites",
    "nav.settings": "Parametres",
    "nav.logout": "Deconnexion",
    "nav.reservations": "Reservations",

    // Landing - NEW DISCOVERY-FOCUSED TONE
    "landing.hero.title": "Organise ton prochain moment de decouverte.",
    "landing.hero.subtitle": "Maintenant ou plus tard. En solo, en famille, entre amis ou entre collegues. Du bon plan spontane a l'organisation complete de ton sejour.",
    "landing.hero.cta": "Commencer maintenant",
    "landing.hero.secondary": "Voir comment ca marche",
    "landing.trusted": "Smart Mobility Companion",
    "landing.features.title": "Tout ce qu'il te faut pour decouvrir",
    "landing.features.subtitle": "Des outils intelligents pour chaque moment d'exploration",
    "landing.features.planning": "Planification intelligente",
    "landing.features.planningDesc": "Itineraires dynamiques avec blocs journaliers, drag & drop et re-planification automatique.",
    "landing.features.compliance": "Formalites en ordre",
    "landing.features.complianceDesc": "Checklist par voyageur: passeports, visas, assurances, autorisations.",
    "landing.features.budget": "Budget maitrise",
    "landing.features.budgetDesc": "Suivi previsionnel vs reel, multi-devises, alertes de depassement.",
    "landing.features.sharing": "Partage simplifie",
    "landing.features.sharingDesc": "Lien de partage en lecture seule pour que tout le monde suive.",
    "landing.features.tasks": "Actions & rappels",
    "landing.features.tasksDesc": "Kanban, assignation, echeances et rappels pour ne rien oublier.",
    "landing.features.journal": "Carnet de voyage",
    "landing.features.journalDesc": "Textes, photos, moments — gardez une trace de chaque experience.",
    "landing.cta.title": "Pret pour ta prochaine decouverte ?",
    "landing.cta.subtitle": "Rejoins ceux qui explorent sereinement.",
    "landing.cta.button": "Creer mon espace",

    // Usage modes - NEW CONTEXTS
    "modes.solo": "En solo",
    "modes.family": "En famille",
    "modes.friends": "Entre amis",
    "modes.work": "Entre collegues",
    "modes.soloDesc": "Ton moment, tes decouvertes.",
    "modes.familyDesc": "Simple, adapte, tout le monde suit.",
    "modes.friendsDesc": "Sortie spontanee ou plan organise.",
    "modes.workDesc": "45 min entre 2 meetings ? On gere.",

    // Quick Deck Module - Complete i18n
    "quickdeck.title": "Qu'est-ce que tu as envie de faire maintenant ?",
    "quickdeck.subtitle": "Choisis une envie, je m'occupe du reste.",
    "quickdeck.cta": "Cree-moi un plan",
    "quickdeck.generating": "Je cherche...",
    "quickdeck.error.generate": "Oups, impossible de generer des suggestions. Reessaie.",
    "quickdeck.saved": "Ajoute a tes favoris !",
    "quickdeck.scan.placeholder": "Fonctionnalite scan bientot disponible !",
    "quickdeck.swap.placeholder": "Nouvelle suggestion en cours...",
    
    // Desires (Level 1)
    "quickdeck.desires.visit": "Visiter",
    "quickdeck.desires.discover": "Decouvrir",
    "quickdeck.desires.eat": "Manger",
    "quickdeck.desires.drink": "Prendre un verre",
    "quickdeck.desires.party": "Faire la fete",
    "quickdeck.desires.chill": "Chiller",
    
    // Constraints (Level 2)
    "quickdeck.constraints.time": "Temps",
    "quickdeck.constraints.budget": "Budget",
    "quickdeck.constraints.distance": "Distance",
    "quickdeck.constraints.vibe": "Ambiance",
    
    // Distance values
    "quickdeck.distance.close": "Proche",
    "quickdeck.distance.medium": "Moyen",
    "quickdeck.distance.far": "Plus loin",
    
    // Vibe values
    "quickdeck.vibe.quiet": "Calme",
    "quickdeck.vibe.lively": "Anime",
    "quickdeck.vibe.indoor": "Interieur",
    "quickdeck.vibe.outdoor": "Exterieur",
    "quickdeck.vibe.open_now": "Ouvert",
    "quickdeck.vibe.quick": "Rapide",
    "quickdeck.vibe.cozy": "Cosy",
    "quickdeck.vibe.trendy": "Tendance",
    "quickdeck.vibe.rooftop": "Rooftop",
    "quickdeck.vibe.club": "Club",
    "quickdeck.vibe.bar": "Bar",
    "quickdeck.vibe.live_music": "Live",
    "quickdeck.vibe.nature": "Nature",
    "quickdeck.vibe.cafe": "Cafe",
    
    // Quick Actions
    "quickdeck.actions.around_me": "Autour de moi",
    "quickdeck.actions.three_hours": "J'ai 3h",
    "quickdeck.actions.scan_here": "C'est quoi ici ?",
    
    // Results
    "quickdeck.results.simplest": "Simple",
    "quickdeck.results.best_ratio": "Top ratio",
    "quickdeck.results.original": "Original",
    
    // Tags
    "quickdeck.tags.open_now": "Ouvert",
    "quickdeck.tags.no_reservation": "Sans resa",

    // Live badges - NEW
    "live.now": "Ouvert",
    "live.soon": "Bientot",
    "live.popular": "Populaire",
    "live.nearby": "A proximite",
    "live.trending": "Tendance",
    "live.minutes": "min",

    // Features page
    "features.title": "Fonctionnalites",
    "features.subtitle": "Decouvrez tout ce que LifePulse peut faire pour vous",

    // Security page
    "security.title": "Securite & RGPD",
    "security.subtitle": "Vos donnees meritent la meilleure protection",
    "security.dataProtection": "Protection des donnees",
    "security.dataProtectionDesc": "Toutes les donnees sont chiffrees et stockees de maniere securisee.",
    "security.privacy": "Confidentialite",
    "security.privacyDesc": "Medias prives, URLs signees, pas de partage sans consentement.",
    "security.gdpr": "Conformite RGPD",
    "security.gdprDesc": "Export de donnees, suppression de compte, registre de traitements.",
    "security.audit": "Audit & traçabilite",
    "security.auditDesc": "Journalisation des actions critiques, retention 30 jours.",

    // Pricing page
    "pricing.title": "Tarifs",
    "pricing.subtitle": "Bientot disponible",
    "pricing.free": "Starter",
    "pricing.freeDesc": "Pour decouvrir",
    "pricing.freeFeatures": "1 voyage actif,2 voyageurs,Fonctionnalites de base",
    "pricing.family": "Pro",
    "pricing.familyPrice": "9.99",
    "pricing.familyDesc": "Pour les deplacements reguliers",
    "pricing.familyFeatures": "Voyages illimites,10 voyageurs,Import reservations,Copilote IA",
    "pricing.premium": "Premium",
    "pricing.premiumPrice": "19.99",
    "pricing.premiumDesc": "Toutes les fonctionnalites",
    "pricing.premiumFeatures": "Tout de Pro,Voyageurs illimites,Mode incident,Export PDF,Support prioritaire",
    "pricing.perMonth": "/mois",
    "pricing.comingSoon": "Bientot disponible",
    "pricing.current": "Plan actuel",

    // Contact page
    "contact.title": "Contactez-nous",
    "contact.subtitle": "Une question ? On est la.",
    "contact.name": "Nom",
    "contact.email": "Email",
    "contact.message": "Message",
    "contact.send": "Envoyer",
    "contact.sent": "Message envoye !",

    // Auth
    "auth.login": "Connexion",
    "auth.loginTitle": "Content de te revoir",
    "auth.loginSubtitle": "Connecte-toi pour acceder a ton espace",
    "auth.google": "Continuer avec Google",
    "auth.processing": "Connexion en cours...",

    // Dashboard - NEW UNIVERSAL
    "dashboard.welcome": "Salut",
    "dashboard.overview": "Ton activite",
    "dashboard.upcomingTrips": "Tes prochains deplacements",
    "dashboard.recentTasks": "Actions recentes",
    "dashboard.quickActions": "Actions rapides",
    "dashboard.noTrips": "Aucun deplacement prevu",
    "dashboard.createFirst": "Cree ton premier plan",
    "dashboard.stats.trips": "Plans",
    "dashboard.stats.tasks": "Actions",
    "dashboard.stats.compliance": "Formalites",
    "dashboard.stats.budget": "Budget",
    "dashboard.liveNow": "En ce moment",
    "dashboard.nextUp": "A venir",

    // Trips - NEW UNIVERSAL
    "trips.title": "Mes plans",
    "trips.create": "Nouveau plan",
    "trips.noTrips": "Aucun plan",
    "trips.noTripsDesc": "Commence par creer ton premier plan de deplacement",
    "trips.name": "Nom",
    "trips.destination": "Destination",
    "trips.startDate": "Date de debut",
    "trips.endDate": "Date de fin",
    "trips.currency": "Devise",
    "trips.family": "Groupe",
    "trips.status": "Statut",
    "trips.travelers": "Participants",
    "trips.bookings": "Reservations",
    "trips.planning": "En preparation",
    "trips.active": "En cours",
    "trips.completed": "Termine",
    "trips.cancelled": "Annule",

    // Trip Detail
    "tripDetail.overview": "Vue d'ensemble",
    "tripDetail.travelers": "Participants",
    "tripDetail.bookings": "Reservations",
    "tripDetail.tasks": "Actions",
    "tripDetail.compliance": "Formalites",
    "tripDetail.budget": "Budget",
    "tripDetail.addTraveler": "Ajouter participant",
    "tripDetail.addBooking": "Ajouter reservation",
    "tripDetail.importBookings": "Importer",
    "tripDetail.addTask": "Ajouter action",
    "tripDetail.addExpense": "Ajouter depense",
    "tripDetail.addCompliance": "Ajouter formalite",
    "tripDetail.readiness": "Preparation",
    "tripDetail.daysUntil": "jours restants",
    "tripDetail.noDays": "Dates a definir",

    // Tasks
    "tasks.title": "Actions",
    "tasks.create": "Nouvelle action",
    "tasks.todo": "A faire",
    "tasks.inProgress": "En cours",
    "tasks.done": "Termine",
    "tasks.priority": "Priorite",
    "tasks.dueDate": "Echeance",
    "tasks.assignee": "Responsable",
    "tasks.high": "Haute",
    "tasks.medium": "Moyenne",
    "tasks.low": "Basse",

    // Compliance
    "compliance.title": "Formalites",
    "compliance.passport": "Passeport",
    "compliance.visa": "Visa / ETA",
    "compliance.insurance": "Assurance",
    "compliance.minorAuth": "Autorisation mineur",
    "compliance.health": "Sante",
    "compliance.other": "Autre",
    "compliance.pending": "En attente",
    "compliance.valid": "Valide",
    "compliance.expiring": "Expire bientot",
    "compliance.expired": "Expire",
    "compliance.blocking": "Bloquant",
    "compliance.important": "Important",
    "compliance.optional": "Optionnel",

    // Budget
    "budget.title": "Budget",
    "budget.planned": "Previsionnel",
    "budget.actual": "Reel",
    "budget.total": "Total",
    "budget.byCategory": "Par categorie",
    "budget.addExpense": "Ajouter depense",
    "budget.hotel": "Hotel",
    "budget.flight": "Vol",
    "budget.transport": "Transport",
    "budget.food": "Restauration",
    "budget.activity": "Activites",
    "budget.shopping": "Shopping",
    "budget.other": "Autre",

    // Settings
    "settings.title": "Parametres",
    "settings.family": "Groupe",
    "settings.members": "Membres",
    "settings.language": "Langue",
    "settings.inviteMember": "Inviter un membre",
    "settings.profile": "Profil",
    "settings.save": "Enregistrer",

    // Common
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.delete": "Supprimer",
    "common.edit": "Modifier",
    "common.create": "Creer",
    "common.close": "Fermer",
    "common.loading": "Chargement...",
    "common.noData": "Aucune donnee",
    "common.search": "Rechercher",
    "common.filter": "Filtrer",
    "common.back": "Retour",
    "common.confirm": "Confirmer",
    "common.add": "Ajouter",

    // Booking types
    "booking.flight": "Vol",
    "booking.hotel": "Hotel",
    "booking.transport": "Transport",
    "booking.activity": "Activite",
    "booking.restaurant": "Restaurant",
    "booking.other": "Autre",
    "booking.locked": "Verrouille",
    "booking.unlocked": "Deverrouille",

    // Day Planner
    "planner.title": "Planificateur",
    "planner.morning": "Matin",
    "planner.afternoon": "Apres-midi",
    "planner.evening": "Soir",
    "planner.addActivity": "Ajouter activite",
    "planner.noActivities": "Aucune activite prevue",
    "planner.stressScore": "Intensite",
    "planner.low": "Light",
    "planner.medium": "Medium",
    "planner.high": "Intense",
    "planner.transport": "Transport",
    "planner.addTransport": "Ajouter trajet",
    "planner.from": "Depart",
    "planner.to": "Arrivee",
    "planner.duration": "Duree",

    // AI Copilot
    "copilot.title": "Assistant IA",
    "copilot.analyze": "Analyser mon plan",
    "copilot.analyzing": "Analyse en cours...",
    "copilot.readiness": "Score de preparation",
    "copilot.gaps": "Points d'attention",
    "copilot.actions": "Actions recommandees",
    "copilot.chat": "Discussion",
    "copilot.askQuestion": "Pose une question sur ton deplacement...",
    "copilot.send": "Envoyer",
    "copilot.thinking": "Reflexion...",
    "copilot.complianceGaps": "Formalites manquantes",
    "copilot.taskGaps": "Actions manquantes",
    "copilot.planningRisks": "Risques de planification",
    "copilot.topActions": "Top 5 actions",

    // Timeline
    "timeline.title": "Timeline",
    "timeline.doorToDoor": "Porte-a-porte",
  },
  en: {
    // Navigation
    "nav.home": "Home",
    "nav.features": "Features",
    "nav.security": "Security & GDPR",
    "nav.pricing": "Pricing",
    "nav.contact": "Contact",
    "nav.login": "Log in",
    "nav.getStarted": "Get Started",
    "nav.dashboard": "My Space",
    "nav.trips": "My Plans",
    "nav.tasks": "Actions",
    "nav.budget": "Budget",
    "nav.compliance": "Compliance",
    "nav.settings": "Settings",
    "nav.logout": "Log out",
    "nav.reservations": "Reservations",

    // Landing - NEW UNIVERSAL TONE
    "landing.hero.title": "Your next moment, now.",
    "landing.hero.subtitle": "Decide in 1 click, go in 1 minute. Work, personal, group — the best plan in real-time.",
    "landing.hero.cta": "Get started now",
    "landing.hero.secondary": "See how it works",
    "landing.trusted": "Smart Mobility Companion",
    "landing.features.title": "What you need, right here, right now",
    "landing.features.subtitle": "Smart tools for every type of trip",
    "landing.features.planning": "Smart Planning",
    "landing.features.planningDesc": "Dynamic itineraries with day blocks, drag & drop and automatic replanning.",
    "landing.features.compliance": "Formalities in order",
    "landing.features.complianceDesc": "Per-traveler checklist: passports, visas, insurance, authorizations.",
    "landing.features.budget": "Budget under control",
    "landing.features.budgetDesc": "Planned vs actual tracking, multi-currency, overspend alerts.",
    "landing.features.sharing": "Easy sharing",
    "landing.features.sharingDesc": "Read-only share link so everyone can follow along.",
    "landing.features.tasks": "Actions & reminders",
    "landing.features.tasksDesc": "Kanban, assignees, deadlines and reminders so nothing gets forgotten.",
    "landing.features.journal": "Travel journal",
    "landing.features.journalDesc": "Text, photos, moments — keep a trace of every experience.",
    "landing.cta.title": "Ready for your next move?",
    "landing.cta.subtitle": "Join those who travel with confidence.",
    "landing.cta.button": "Create my space",

    // Usage modes - NEW
    "modes.pro": "On the go",
    "modes.explore": "Personal discovery",
    "modes.family": "Group outing",
    "modes.proDesc": "45 min between meetings? We got you.",
    "modes.exploreDesc": "Discover hidden gems around you.",
    "modes.familyDesc": "Simple, reliable, everyone follows.",

    // Quick Deck Module - Complete i18n
    "quickdeck.title": "What do you feel like doing right now?",
    "quickdeck.subtitle": "Pick a vibe, I'll handle the rest.",
    "quickdeck.cta": "Create my plan",
    "quickdeck.generating": "Searching...",
    "quickdeck.error.generate": "Oops, couldn't generate suggestions. Try again.",
    "quickdeck.saved": "Added to favorites!",
    "quickdeck.scan.placeholder": "Scan feature coming soon!",
    "quickdeck.swap.placeholder": "Finding a new suggestion...",
    
    // Desires (Level 1)
    "quickdeck.desires.visit": "Visit",
    "quickdeck.desires.discover": "Discover",
    "quickdeck.desires.eat": "Eat",
    "quickdeck.desires.drink": "Grab a drink",
    "quickdeck.desires.party": "Party",
    "quickdeck.desires.chill": "Chill",
    
    // Constraints (Level 2)
    "quickdeck.constraints.time": "Time",
    "quickdeck.constraints.budget": "Budget",
    "quickdeck.constraints.distance": "Distance",
    "quickdeck.constraints.vibe": "Vibe",
    
    // Distance values
    "quickdeck.distance.close": "Close",
    "quickdeck.distance.medium": "Medium",
    "quickdeck.distance.far": "Further",
    
    // Vibe values
    "quickdeck.vibe.quiet": "Quiet",
    "quickdeck.vibe.lively": "Lively",
    "quickdeck.vibe.indoor": "Indoor",
    "quickdeck.vibe.outdoor": "Outdoor",
    "quickdeck.vibe.open_now": "Open now",
    "quickdeck.vibe.quick": "Quick",
    "quickdeck.vibe.cozy": "Cozy",
    "quickdeck.vibe.trendy": "Trendy",
    "quickdeck.vibe.rooftop": "Rooftop",
    "quickdeck.vibe.club": "Club",
    "quickdeck.vibe.bar": "Bar",
    "quickdeck.vibe.live_music": "Live",
    "quickdeck.vibe.nature": "Nature",
    "quickdeck.vibe.cafe": "Cafe",
    
    // Quick Actions
    "quickdeck.actions.around_me": "Around me",
    "quickdeck.actions.three_hours": "I have 3h",
    "quickdeck.actions.scan_here": "What's this?",
    
    // Results
    "quickdeck.results.simplest": "Simple",
    "quickdeck.results.best_ratio": "Best ratio",
    "quickdeck.results.original": "Original",
    
    // Tags
    "quickdeck.tags.open_now": "Open",
    "quickdeck.tags.no_reservation": "No booking",

    // Live badges - NEW
    "live.now": "Open",
    "live.soon": "Soon",
    "live.popular": "Popular",
    "live.nearby": "Nearby",
    "live.trending": "Trending",
    "live.minutes": "min",

    // Features page
    "features.title": "Features",
    "features.subtitle": "Discover everything LifePulse can do for you",

    // Security page
    "security.title": "Security & GDPR",
    "security.subtitle": "Your data deserves the best protection",
    "security.dataProtection": "Data Protection",
    "security.dataProtectionDesc": "All data is encrypted and securely stored.",
    "security.privacy": "Privacy",
    "security.privacyDesc": "Private media, signed URLs, no sharing without consent.",
    "security.gdpr": "GDPR Compliance",
    "security.gdprDesc": "Data export, account deletion, processing register.",
    "security.audit": "Audit & Traceability",
    "security.auditDesc": "Critical action logging, 30-day retention.",

    // Pricing page
    "pricing.title": "Pricing",
    "pricing.subtitle": "Coming soon",
    "pricing.free": "Starter",
    "pricing.freeDesc": "To discover",
    "pricing.freeFeatures": "1 active trip,2 travelers,Basic features",
    "pricing.family": "Pro",
    "pricing.familyPrice": "9.99",
    "pricing.familyDesc": "For regular travel",
    "pricing.familyFeatures": "Unlimited trips,10 travelers,Reservation import,AI Copilot",
    "pricing.premium": "Premium",
    "pricing.premiumPrice": "19.99",
    "pricing.premiumDesc": "All features",
    "pricing.premiumFeatures": "Everything in Pro,Unlimited travelers,Incident mode,PDF export,Priority support",
    "pricing.perMonth": "/month",
    "pricing.comingSoon": "Coming soon",
    "pricing.current": "Current plan",

    // Contact page
    "contact.title": "Contact Us",
    "contact.subtitle": "Have a question? We're here.",
    "contact.name": "Name",
    "contact.email": "Email",
    "contact.message": "Message",
    "contact.send": "Send",
    "contact.sent": "Message sent!",

    // Auth
    "auth.login": "Log in",
    "auth.loginTitle": "Good to see you",
    "auth.loginSubtitle": "Sign in to access your space",
    "auth.google": "Continue with Google",
    "auth.processing": "Signing in...",

    // Dashboard - NEW UNIVERSAL
    "dashboard.welcome": "Hey",
    "dashboard.overview": "Your activity",
    "dashboard.upcomingTrips": "Your upcoming moves",
    "dashboard.recentTasks": "Recent actions",
    "dashboard.quickActions": "Quick actions",
    "dashboard.noTrips": "No trips planned",
    "dashboard.createFirst": "Create your first plan",
    "dashboard.stats.trips": "Plans",
    "dashboard.stats.tasks": "Actions",
    "dashboard.stats.compliance": "Compliance",
    "dashboard.stats.budget": "Budget",
    "dashboard.liveNow": "Live now",
    "dashboard.nextUp": "Next up",

    // Trips - NEW UNIVERSAL
    "trips.title": "My Plans",
    "trips.create": "New Plan",
    "trips.noTrips": "No plans",
    "trips.noTripsDesc": "Start by creating your first travel plan",
    "trips.name": "Name",
    "trips.destination": "Destination",
    "trips.startDate": "Start date",
    "trips.endDate": "End date",
    "trips.currency": "Currency",
    "trips.family": "Group",
    "trips.status": "Status",
    "trips.travelers": "Participants",
    "trips.bookings": "Bookings",
    "trips.planning": "Planning",
    "trips.active": "Active",
    "trips.completed": "Completed",
    "trips.cancelled": "Cancelled",

    // Trip Detail
    "tripDetail.overview": "Overview",
    "tripDetail.travelers": "Participants",
    "tripDetail.bookings": "Bookings",
    "tripDetail.tasks": "Actions",
    "tripDetail.compliance": "Compliance",
    "tripDetail.budget": "Budget",
    "tripDetail.addTraveler": "Add participant",
    "tripDetail.addBooking": "Add booking",
    "tripDetail.importBookings": "Import",
    "tripDetail.addTask": "Add action",
    "tripDetail.addExpense": "Add expense",
    "tripDetail.addCompliance": "Add compliance item",
    "tripDetail.readiness": "Readiness",
    "tripDetail.daysUntil": "days to go",
    "tripDetail.noDays": "Dates TBD",

    // Tasks
    "tasks.title": "Actions",
    "tasks.create": "New Action",
    "tasks.todo": "To Do",
    "tasks.inProgress": "In Progress",
    "tasks.done": "Done",
    "tasks.priority": "Priority",
    "tasks.dueDate": "Due date",
    "tasks.assignee": "Assignee",
    "tasks.high": "High",
    "tasks.medium": "Medium",
    "tasks.low": "Low",

    // Compliance
    "compliance.title": "Compliance",
    "compliance.passport": "Passport",
    "compliance.visa": "Visa / ETA",
    "compliance.insurance": "Insurance",
    "compliance.minorAuth": "Minor authorization",
    "compliance.health": "Health",
    "compliance.other": "Other",
    "compliance.pending": "Pending",
    "compliance.valid": "Valid",
    "compliance.expiring": "Expiring soon",
    "compliance.expired": "Expired",
    "compliance.blocking": "Blocking",
    "compliance.important": "Important",
    "compliance.optional": "Optional",

    // Budget
    "budget.title": "Budget",
    "budget.planned": "Planned",
    "budget.actual": "Actual",
    "budget.total": "Total",
    "budget.byCategory": "By category",
    "budget.addExpense": "Add expense",
    "budget.hotel": "Hotel",
    "budget.flight": "Flight",
    "budget.transport": "Transport",
    "budget.food": "Food",
    "budget.activity": "Activities",
    "budget.shopping": "Shopping",
    "budget.other": "Other",

    // Settings
    "settings.title": "Settings",
    "settings.family": "Group",
    "settings.members": "Members",
    "settings.language": "Language",
    "settings.inviteMember": "Invite member",
    "settings.profile": "Profile",
    "settings.save": "Save",

    // Common
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.create": "Create",
    "common.close": "Close",
    "common.loading": "Loading...",
    "common.noData": "No data",
    "common.search": "Search",
    "common.filter": "Filter",
    "common.back": "Back",
    "common.confirm": "Confirm",
    "common.add": "Add",

    // Booking types
    "booking.flight": "Flight",
    "booking.hotel": "Hotel",
    "booking.transport": "Transport",
    "booking.activity": "Activity",
    "booking.restaurant": "Restaurant",
    "booking.other": "Other",
    "booking.locked": "Locked",
    "booking.unlocked": "Unlocked",

    // Day Planner
    "planner.title": "Day Planner",
    "planner.morning": "Morning",
    "planner.afternoon": "Afternoon",
    "planner.evening": "Evening",
    "planner.addActivity": "Add activity",
    "planner.noActivities": "No activities planned",
    "planner.stressScore": "Intensity",
    "planner.low": "Light",
    "planner.medium": "Medium",
    "planner.high": "Intense",
    "planner.transport": "Transport",
    "planner.addTransport": "Add transport",
    "planner.from": "From",
    "planner.to": "To",
    "planner.duration": "Duration",

    // AI Copilot
    "copilot.title": "AI Assistant",
    "copilot.analyze": "Analyze my plan",
    "copilot.analyzing": "Analyzing...",
    "copilot.readiness": "Readiness score",
    "copilot.gaps": "Attention points",
    "copilot.actions": "Recommended actions",
    "copilot.chat": "Chat",
    "copilot.askQuestion": "Ask a question about your trip...",
    "copilot.send": "Send",
    "copilot.thinking": "Thinking...",
    "copilot.complianceGaps": "Compliance gaps",
    "copilot.taskGaps": "Action gaps",
    "copilot.planningRisks": "Planning risks",
    "copilot.topActions": "Top 5 actions",

    // Timeline
    "timeline.title": "Timeline",
    "timeline.doorToDoor": "Door-to-door",
  }
};

export default translations;
